import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/gallery");
  };

  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Quick Links</h4>
              <Link to="/" className="btn btn-link">
                Home
              </Link>
              <Link to="/about" className="btn btn-link">
                About Us
              </Link>
              <Link to="/courses" className="btn btn-link">
                Courses
              </Link>
              <Link to="/services" className="btn btn-link">
                Services
              </Link>
              {/* <Link to="/about" className="btn btn-link">
                Resorces
              </Link> */}
              <Link to="/contact" className="btn btn-link">
                Contact Us
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3"></h4>
              <br />
              <Link to="/gallery" className="btn btn-link">
                Gallery
              </Link>
              <Link to="/" className="btn btn-link">
                Resources
              </Link>
              <Link to="/" className="btn btn-link">
                News and Events
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Contact</h4>
              <p className="mb-2">
                <i className="fa fa-map-marker me-3"></i>1st Floor, Star Plaza,
                18-1-49, KT Rd, Srinivasa Nagar, Tirupati, Andhra Pradesh 517501
              </p>
              <p className="mb-2">
                <i className="fa fa-phone me-3"></i>072072 13437
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3"></i>
                <a className="text-white" href="mailto:info@dikshasea.in">
                  info@dikshasea.in
                </a>
              </p>
              <div className="d-flex pt-2">
                <a
                  className="btn btn-outline-light btn-social"
                  target="_blank"
                  href="https://twitter.com/dikshasea?lang=en"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  target="_blank"
                  href="https://www.facebook.com/@Dikshasea/?mibextid=ZbWKwL"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  target="_blank"
                  href="https://youtube.com/@dikshasea72?si=n3iGzhNykVDbEHt3"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  target="_blank"
                  href="https://www.linkedin.com/company/dikshasea/"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  target="_blank"
                  href="https://www.instagram.com/dikshasea?igsh=Z2Y0amExeXVueWhs"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Gallery</h4>
              <div className="row g-2 pt-2">
                {[
                  "1.jpeg",
                  "2.jpeg",
                  "3.jpeg",
                  "4.jpeg",
                  "8.jpg",
                  "10.jpg",
                  "11.jpg",
                  "12.jpg",
                  "13.jpg",
                ].map((img, index) => (
                  <div className="col-4" key={index}>
                    <img
                      className="img-fluid bg-light p-1"
                      src={`../../img/gallery/${img}`}
                      onClick={() => handleClick()}
                      alt={`Gallery ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy;{" "}
                <Link className="border-bottom" to="/">
                  Diksha SEA
                </Link>
                , All Rights Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                <div className="footer-menu">
                  <a href="#">Terms & Conditions</a>
                  <a href="#">Privacy Policy</a>
                  <a href="#">Help</a>
                  <a href="#">FAQs</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Link
        to="https://api.whatsapp.com/send?phone=[7207213437]&amp;text=hello"
        className="whatsappButton"
        id="whatsappButton"
        style={{ display: "inline", opacity: "1.0798" }}
      >
        <i className="bi bi-whatsapp"></i>
      </Link>

      <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top">
        <i className="bi bi-arrow-up"></i>
      </a>
    </div>
  );
};

export default Footer;
